module.exports = __webpack_public_path__ + "assets/img/background-trackInfo.93085fc4.png";